import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { toast } from 'react-toastify';
import { useAuth } from '../api/services/auth';
import { HalfCircleSpinner } from 'react-epic-spinners';
import { Button } from './ui/button';

const OtpForm = () => {
    const [otp, setOtp] = useState(null);
    const [errors, setErrors] = useState({});
    const { verifyOtp, showLoader } = useAuth();

    // Validate OTP input
    const validateOtp = () => {
        let errors = {};
        let isValid = true;
        if (!otp) {
            isValid = false;
            errors['otp'] = 'Please enter the OTP sent to your email.';
            toast.error('Please enter the OTP sent to your email.');
        }
        setErrors(errors);
        return isValid;
    };

    // Handle OTP verification
    const otpHandler = (event) => {
        event.preventDefault();

        if (validateOtp()) {
            const { username, password } = window.history.state;

            if (username && password && otp) {
                verifyOtp(username, password, Number(otp));
            }
        }
    };

    return (
        <form className="space-y-4" onSubmit={otpHandler}>
            <div className="flex justify-center">
                <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderSeparator={<span className="mx-1 text-ink-400">-</span>}
                    renderInput={(props) => (
                        <input
                            {...props}
                            type='number'
                            className='otp-input h-12 !w-10 rounded-md border border-parch-200 bg-white text-center text-lg font-semibold text-ink-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20'
                        />
                    )}
                />
            </div>
            <Button type="submit" className="w-full" disabled={showLoader}>
                Verify OTP
                {showLoader && (
                    <HalfCircleSpinner size={18} style={{ display: 'inline-block' }} />
                )}
            </Button>
        </form>
    );
}

export default OtpForm;
